<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-repository`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M25.072 4.335l18.036 12A2 2 0 0144 18v24a2 2 0 01-2 2H6a2 2 0 01-2-2V18a2 2 0 01.89-1.663l17.963-12a2 2 0 012.219-.002zm-1.106 4.069L8 19.069V40h32V19.072L23.966 8.404zm6.302 11.303l3.864 1.035-4.141 15.455-3.864-1.035 4.141-15.455zM21.485 19l2.829 2.828-5.683 5.682 5.268 5.268-2.828 2.829-7.778-7.779.025-.025-.318-.318L21.485 19z"/></svg>
</template>
<script>

export default {
  name: 'IconRepository',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
